import utils from '../common/utils.js';
import { partPath } from '../common/variables.js';
import { getRequestByName, logout } from '../common/commonUtil';

$(function () {
  let actualUrl = utils.getDataFromUrl('actualUrl');
  if (actualUrl) {
    actualUrl = decodeURIComponent(actualUrl);
  }

  // 延时1s如果还未跳转则出现loading图案
  setTimeout(function () {
    $('#loadingImg').show();
  }, 1000);

  // 清空用户相关缓存信息,清理前保存部分信息，以后后面使用
  let actualSys = window.localStorage.getItem('actualSys');
  let headerClassify = window.localStorage.getItem('headerClassify');
  function clearGatewayLocalStorage() {
    window.localStorage.removeItem('blocks');
    window.localStorage.removeItem('headerClassify');
    window.localStorage.removeItem('user_rights');
    window.localStorage.removeItem('expTime');
    window.localStorage.removeItem('configs');
    window.localStorage.removeItem('ccTenantUserInfo');
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('fastAddress');
    window.localStorage.removeItem('fastAddress_location');
    window.localStorage.removeItem('systemVersion');
    window.localStorage.removeItem('gateway_navs');
    window.localStorage.removeItem('actualSys');
    window.localStorage.removeItem('bigdata_multi_system');
  }
  clearGatewayLocalStorage();

  /* 获取config配置 */
  var configSuccess = false;
  $.ajax({
    type: 'get',
    async: false,
    url: partPath + '/all/config',
    contentType: 'application/json;charset=UTF-8',
    dataType: 'json',
    success: function (data) {
      if (data.commonResponse.success) {
        var configs = data.configMap;
        window.localStorage.setItem('configs', JSON.stringify(configs));
        configSuccess = true;
      } else {
        console.log('获取配置信息失败：' + data.commonResponse.errorDesc);
      }
    },
  });

  if (!configSuccess) {
    alert('系统配置信息加载失败!');
    // 登出
    logout();
  }

  /* 根据config配置的autoGetThirdInstanceUrl，是否需要自动获取实例地址，初始化好相关第三方实例根地址 */
  var configs = JSON.parse(window.localStorage.getItem('configs'));
  if (configs.autoGetThirdInstanceUrl) {
    // 获取快融实例地址,用于交互功能（一键报题、一键稿件2.0），快融头部渲染，serviceId：NewsEditingSuite
    var fastAddress;
    var fastAddress_location;
    $.ajax({
      type: 'get',
      async: false,
      url: partPath + '/third-instance-base-url/NewsEditingSuite',
      contentType: 'application/json;charset=UTF-8',
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          fastAddress = data.baseUrl;

          /*
           * 正确地址示例：//192.168.20.54:90/gateway/
           * 校对地址
           * 1.去掉地址前后空格
           * 2.如果没有以/结尾，自动补上/
           * */
          fastAddress = $.trim(fastAddress);
          if (fastAddress.lastIndexOf('/') != fastAddress.length - 1) {
            fastAddress = fastAddress + '/';
          }

          fastAddress_location = data.location;

          console.info('fastAddress_location:' + fastAddress_location);
          console.info('fastAddress：' + fastAddress);
        } else {
          console.error('获取快融初始化地址失败，失败原因：' + data.errorDesc);
        }
      },
    });

    if (!fastAddress) {
      alert(
        '自动获取快融实例[ NewsEditingSuite ]根地址失败，请检查该租户是否开通注册该实例！'
      );
    } else {
      // 将快融实例地址放入缓存，后续相关操作直接读取缓存
      window.localStorage.setItem('fastAddress', fastAddress);
      window.localStorage.setItem('fastAddress_location', fastAddress_location);
    }
  } else {
    window.localStorage.setItem('fastAddress', configs.fastAddress);
    window.localStorage.setItem('fastAddress_location', 'private');
    configs.autoGetThirdInstanceUrl = true;
  }
  /* 获取用户信息 */
  var userInfoSuccess = false;
  $.ajax({
    type: 'get',
    async: false,
    url: partPath + '/user/userInfo',
    contentType: 'application/json;charset=UTF-8',
    dataType: 'json',
    success: function (data) {
      if (data.commonResponse.success) {
        var userInfo = {};
        if (data.tenantId) {
          userInfo.tenantId = data.tenantId;
        }
        if (data.ducpTenantId) {
          userInfo.ducpTenantId = data.ducpTenantId;
        }
        userInfo.localTenantId = data.localTenantId;
        userInfo.userId = data.userId;
        userInfo.userName = data.userName;
        userInfo.token = data.token || 'emptyToken'; // 防止访问台内接口报错（无token传递）
        if (data.picture) {
          userInfo.picture = data.picture;
        }
        window.localStorage.setItem(
          'ccTenantUserInfo',
          JSON.stringify(userInfo)
        );
        userInfoSuccess = true;
      } else {
        console.log('获取用户信息失败：' + data.commonResponse.errorDesc);
      }
    },
  });

  if (!userInfoSuccess) {
    alert('用户信息加载失败!');
    // 登出
    logout();
  }

  /* 获取token 、菜单、权限集合 */
  var userInfo = JSON.parse(window.localStorage.getItem('ccTenantUserInfo'));
  var userId = userInfo.userId;
  // 在 tenantId 为空的情况，即当前登陆并不是融云的租户id，使用 ducpTenantId，即当前外系统租户id，获取token时会用该租户去映射到融云租户id，当有指定租户id前缀时，其实映射id为该前缀 + ducpTenantId
  var tenantId = userInfo.tenantId || userInfo.ducpTenantId;
  var tokenSuccess = false;
  $.ajax({
    type: 'get',
    async: false,
    url: partPath + '/auth/token?userId=' + userId + '&tenantId=' + tenantId,
    contentType: 'application/json;charset=UTF-8',
    dataType: 'json',
    success: function (data) {
      if (data.commonResponse.success) {
        var token = data.access_token;
        // 将token放置在localStorage中
        window.localStorage.setItem('token', token);

        var infos = token.split('.');
        // 第二节包含有token的信息,解码获取token中包含的type信息
        var info = JSON.parse(Base64.base64decode(infos[1]));
        var expTime = info['exp'];
        window.localStorage.setItem('expTime', expTime);

        let tenantInfo = data.tenantInfo || {};
        let industryId = tenantInfo.industryId;
        let industryName = tenantInfo.industryName;
        if (industryId) {
          window.localStorage.setItem('systemVersion', 'industry');
          userInfo.industryId = industryId;
          userInfo.industryName = industryName;

          // 更新缓存中的用户信息
          window.localStorage.setItem(
            'ccTenantUserInfo',
            JSON.stringify(userInfo)
          );
        }

        if (!userInfo.tenantId) {
          // 如果没有租户id，需要从token中获取真实映射的租户id
          var tokenTenantId = info['tenantId'];
          userInfo.tenantId = tokenTenantId;

          // 更新缓存中的用户信息
          window.localStorage.setItem(
            'ccTenantUserInfo',
            JSON.stringify(userInfo)
          );
        }

        // 权限集合
        var rights = data.rights;
        if (rights) {
          window.localStorage.setItem('user_rights', JSON.stringify(rights));
        }

        // 菜单
        var blocks = data.blocks;
        var saveBlocks = [];
        if (blocks) {
          // 生成新的菜单信息
          $.each(blocks, function (index, block) {
            var appName = block['appName'];

            if (!block['loginRight']) {
              console.log('无登录产品[ ' + appName + ' ]的权限！');
              alert('无登录产品[ ' + appName + ' ]的权限！');
              return;
            }

            if (!block['packageOk']) {
              console.log('产品[ ' + appName + ' ]套餐已经失效，请检查！');
              alert('产品[ ' + appName + ' ]套餐已经失效，请检查！');
              return;
            }

            block['loginRight'] = undefined;
            block['packageOk'] = undefined;

            saveBlocks.push(block);
          });
        } else {
          console.log('无开通的大数据相关产品，请检查后再登陆！');
          alert('无开通的大数据相关产品，请检查后再登陆！');
          // 登出
          logout();
        }

        if (saveBlocks.length == 0) {
          console.error('无有效开通的大数据相关产品，请检查后再登陆！');
          alert('无有效开通的大数据相关产品，请检查后再登陆！');
          // 登出
          logout();
        }

        window.localStorage.setItem('blocks', JSON.stringify(saveBlocks));

        tokenSuccess = true;
      } else {
        console.error(
          '权限相关信息加载失败，异常信息：' + data.commonResponse.errorDesc
        );
        alert(
          '权限相关信息加载失败，异常信息：' + data.commonResponse.errorDesc
        );
        // 登出
        logout();
      }
    },
  });

  if (!tokenSuccess) {
    alert('权限相关信息加载失败!');
    // 登出
    logout();
  }

  // 重新获取tenantId
  tenantId = userInfo.tenantId || userInfo.ducpTenantId;

  // 获取门户导航信息

  /*
   * head头指定 gateway 为门户默认头样式，如果地址中传递了headerClassify，则直接使用，如果没传则根据版本判断
   * gateway_ducp_fast 为ducp多租户快融版本集成头样式
   * gateway_cre_fast 为ducp私有化（新版cre）快融版本集成头样式
   */
  let headerClassifyFromUrl = getRequestByName('headerClassify');
  if (headerClassifyFromUrl) {
    headerClassify = headerClassifyFromUrl.replaceAll('/', '').trim();
  } else {
    // if(!configs){
    //   configs = JSON.parse(window.localStorage.getItem('configs'));
    // }
    // let version = configs.version;
    // if(version.indexOf('DUCP') !== -1 || version.indexOf('HNRB') !== -1){
    //   headerClassify = 'gateway_ducp_fast';
    // }else if(version.indexOf('CRE') !== -1){
    //   headerClassify = 'gateway_cre_fast';
    // }else if(version.indexOf('CDV') !== -1){
    //   headerClassify = 'gateway_cdv_fast';
    // }else{
    //   headerClassify = 'gateway';
    // }
  }
  window.localStorage.setItem('headerClassify', headerClassify || 'gateway');

  /*
   * 获取系统版本和门户导航信息，存在标准版和行业大数据版
   */
  let systemVersion = localStorage.getItem('systemVersion');
  let gateway_navs = [];
  function getNav() {
    let configs = JSON.parse(window.localStorage.getItem('configs'));
    let ccTenantUserInfo = JSON.parse(
      window.localStorage.getItem('ccTenantUserInfo')
    );
    let token = window.localStorage.getItem('token');

    // 获取导航信息
    if (systemVersion === 'industry') {
      $.ajax({
        type: 'GET',
        async: false,
        url: `${configs.zuulServerUrl}/operatemanager/v3/front-app-menu/tenant-menu-list/${systemVersion}/0`,
        data: {
          industry_id: ccTenantUserInfo.industryId || undefined,
        },
        contentType: 'application/json;charset=UTF-8',
        dataType: 'json',
        beforeSend: function (XHR) {
          XHR.setRequestHeader('token', token); // 只需传递访问令牌 token
        },
        success: function (data) {
          if (data.success) {
            let resultList = data.resultList || [];
            gateway_navs = resultList;
            window.localStorage.setItem(
              'gateway_navs',
              JSON.stringify(gateway_navs)
            );
          } else {
            console.log('获取不同版本导航信息失败');
          }
        },
      });
    }
  }
  getNav();

  /*
   * 跳转应用
   * 20200509 新增逻辑，可以指定项目跳转
   *
   * 从url中检测是否有指定的应用跳转信息（appId）
   * 300 热点发现
   * 400 线索汇聚
   * 500 传播运营
   * 600 视频指数
   * 700 知识库
   * 750 爆料中心
   * 1000 数据大屏
   */
  var blocks = JSON.parse(window.localStorage.getItem('blocks')) || [];

  // 默认重定向地址，为门户产品跳转地址
  var redirectUrl = `${partPath}/views/home_page/home_page.html?timestamp=${new Date().getTime()}`;

  // 如果为行业大数据版，跳转门户第一个导航页
  if (systemVersion === 'industry' && gateway_navs.length) {
    redirectUrl = `${partPath}/views${
      gateway_navs[0].menuUrl
    }?timestamp=${new Date().getTime()}`;
  }

  // 如果没有门户项目，则跳转到第一个产品页面
  if (blocks.length && blocks[0].appId !== 0) {
    redirectUrl = blocks[0].path + '?timestamp=' + new Date().getTime();
  }

  // 客户定制版本的页面跳转逻辑
  function customVersionJumpFunc() {
    // 跳转到宿迁定制页面
    if (
      tenantId === '4091' ||
      tenantId === '1d2acfe5db6940f7b490b6f9cf91c85e' ||
      tenantId === '109'
    ) {
      redirectUrl = `${partPath}/views/social_hotspot/social_hotspot.html?timestamp=${new Date().getTime()}`;
    }else if(tenantId === '3705'){
      redirectUrl = `${partPath}/views/complex/complex.html?timestamp=${new Date().getTime()}`;
    }
  }
  customVersionJumpFunc();

  // 重新获取缓存后，如果带有actualUrl，跳转到真实需要跳转的页面
  if (actualUrl) {
    redirectUrl = actualUrl;
  }
  var appId = getRequestByName('appId');

  // 先判断url中是否传递了appId，如果传递了说明是拆分展示的多系统
  if (appId) {
    window.localStorage.setItem('bigdata_multi_system', 1);
  }

  if (actualSys) {
    window.localStorage.setItem('actualSys', actualSys);
    actualSys = JSON.parse(actualSys);
    appId = actualSys.appId + '';
  }

  if (appId) {
    var hasMatch = false;

    // 有指定的appId，需要校验该租户是否开通了该产品
    $.each(blocks, function (index, block) {
      var bappId = block['appId'];

      if (String(bappId) === appId) {
        hasMatch = true;
        redirectUrl = block['path'] + '?timestamp=' + new Date().getTime();
      }
    });

    if (!hasMatch) {
      alert(
        '未检测出来租户开通了指定跳转的产品【' +
          appId +
          '】，即将跳转至已开通产品的首页！'
      );
    }
  }

  // 处理其他页面跳转大数据门户首页
  if (actualSys && appId === '0') {
    window.localStorage.removeItem('actualSys');
    redirectUrl = actualSys.actualUrl;
  }

  console.log(redirectUrl);
  window.location.href = redirectUrl;
});
